import { IntegrationFlowRequestResultModel } from "client/Api/IntegrationBuilder/integrationBuilderFlows";
import { isNotNil, setTrackingId } from "client/Misc/utils";
import { ReactElement } from "react";
import { getStatusCodeKind, HttpStatusKind } from "./common";
import styles from "./StepResponse.module.less";
import classNames from "classnames";
import { localize } from "client_legacy/ndaw/culture";
import { Space, ValidationError } from "client/Components";

export type StepResponseProps = {
	response: IntegrationFlowRequestResultModel;
};

export const StepResponse = (props: StepResponseProps): ReactElement => {
	const {
		content,
		statusCode,
		reasonPhrase,
		isBinaryContent
	} = props.response;

	const httpCodeStyles: string | undefined = isNotNil(statusCode)
		? httpStatusCodeKindToStyles[getStatusCodeKind(statusCode)]
		: undefined;

	return (
		<div
			className={classNames(
				styles.root,
				httpCodeStyles
			)}
		>
			{isNotNil(statusCode) && (
				<>
					<div className={styles.header}>
						{localize("_Status")}:
						<Space />
						<span
							{...setTrackingId("step-response-status-code")}
							className={styles.status}
						>
							{statusCode}
							<Space />
							{reasonPhrase}
						</span>
					</div>
					<hr className={styles.divider}/>
				</>
			)}

			{isBinaryContent && (
				<ValidationError
					message={localize("_ResultContainsDataThatIsNotTextBased")}
					trackingId="result-binary-content-error"
				/>
			)}

			{content && (
				<pre
					{...setTrackingId("step-response-content")}
					className={styles.result}
				>
					{content}
				</pre>
			)}
		</div>
	);
};
StepResponse.displayName = "stepResponse";

const httpStatusCodeKindToStyles: Record<HttpStatusKind, string> = {
	["successful"]: styles.root_success,
	["error"]: styles.root_error
};
